import React, { useCallback, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { UpdateContext } from "../../main-context";

export default function Modal({ header, errorHtml, footerType, url }) {
  const history = useHistory();
  const update_context = useContext(UpdateContext);
  const [local_url, set_local_url] = useState("");
  const footerClick = useCallback(() => {
    window.$("#jf-alert-modal").modal("hide");
    history.push(local_url);
  }, [history, local_url]);

  useEffect(() => {
    if (url) {
      set_local_url(url);
      window.$("#jf-alert-modal").modal();
      update_context.update_ui_context((prev) => ({
        ...prev,
        modal: {
          ...prev.modal,
          url: "",
        },
      }));
    }
  }, [update_context, url]);

  return (
    <div className="modal fade" id="jf-alert-modal" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal">
              &times;
            </button>
            <h4 className="modal-title">{header}</h4>
          </div>
          <div className="modal-body">
            <p
              className="modal-body-paragraf"
              dangerouslySetInnerHTML={{
                __html: errorHtml,
              }}
            ></p>
          </div>
          <div className="modal-footer">
            {footerType === "inspection" && (
              <span id="jf-alert-modal-footer-custom">
                <span
                  style={{
                    width: "310px",
                    marginTop: "-4px",
                    textAlign: "left",
                    float: "left",
                    fontWeight: "bold",
                  }}
                >
                  Some inspection steps have been disabled due to the items
                  above.
                </span>
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={footerClick}
                >
                  Open Partial Inspection
                </button>
              </span>
            )}

            <button
              type="button"
              className="btn btn-default"
              data-dismiss="modal"
              onClick={() => {
                window.jfalertbreak = true;
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
